import { defineStore } from 'pinia';
import Network from "~/utils/network";
import { useBnplApplicationStore } from './bnplapplication';
import { useCartStore } from './cart';
import { useProfileStore } from './profile';


const urls = {
  createPrescore: `/bnpl/pre-score`, // POST
  sendSuccessEmail: (publicId) => `/bnpl/pre-score/successful_email/${publicId}`, // POST
  getOffer: (offerId) => `/bnpl/external/offer/${offerId}`, // GET
};

/**
 * BNPL Application store
*/

export const usePrescoreStore = defineStore('prescore', {
  state: () => {
    return {
      offerId: null,
      redirectUrl: '',
      merchantId: null,
      offer: {}
    };
  },
  actions: {
    createPrescore: async function () {
      const bnplApplicationStore = useBnplApplicationStore();
      const cartStore = useCartStore();
      try {
        let data = await Network.http(urls.createPrescore, {
          method: 'POST',
          body: {
            offerId: this.offerId,
            merchantId: this.merchantId,
            totalAmount: cartStore.cart.sum,
            financier: bnplApplicationStore.financer,
            redirectUrl: this.redirectUrl,
            itemName: cartStore.cart.name,
            itemDescription: cartStore.cart.description
          }
        });
        bnplApplicationStore.publicId = data.publicId;
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    getOffer: async function (offerId) {
      try {
        let data = await Network.http(urls.getOffer(offerId), {
          method: 'GET',
        });
        this.offer = data;
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    sendSuccessEmail: async function () {
      const bnplApplicationStore = useBnplApplicationStore();
      try {
        await Network.http(urls.sendSuccessEmail(bnplApplicationStore.publicId), {
          method: 'POST'
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
  },
  getters: {
    getActiveOffer: function () {
      return this.selectedOffer;
    },
  },
}
);
